import React from 'react';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import UserInfo from '@ifeng/ui_pc_userInfo';
import Search from '@ifeng/ui_pc_search';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Nav from '../../../../components/nav/';
import Logo from './logo/';
import Ppx from '../../components/ppx';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { nav, search, adMap, topAd, bannerAd, logoAd, logoPPX, logo, domain, breadCrumbdata } = content;
        const logoData = { logo, domain, breadCrumbdata };

        return (
            <div>
                <div className={styles.header}>
                    <Chip id="20002" type="struct" title="导航" groupName="头部" content={nav}>
                        <Nav />
                    </Chip>
                    <div className={styles.user}>
                        <UserInfo />
                    </div>
                </div>
                <div className={styles.topAd_box}>
                    {bannerAd ? (
                        <Ad content={bannerAd} styleName={styles.topAd} />
                    ) : (
                        <Ad content={topAd} styleName={styles.topAd} />
                    )}
                </div>
                <div className={styles.search_bar}>
                    <Logo content={logoData} />
                    <Chip id="20005" type="struct" title="搜索" groupName="头部" content={search}>
                        <Search />
                    </Chip>
                    {adMap.logoAd ? <Ad content={logoAd} /> : ''}
                    {!adMap.logoAd && logoPPX ? (
                        <Chip id="25028" type="static" title="泡泡直播" groupName="头部" user="dev" content={logoPPX}>
                            <Ppx />
                        </Chip>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
